export const ActivityReportLinkCo2 = "https://s3.ap-southeast-2.amazonaws.com/library.bigbuddy.io/download/report/Nature/Nature_Deal_report_v3.xlsx";

const creative = [
    {
        "_id": "6457540de8d1455f3068fa81",
        "ad_name": "Ocean Spray Healthy Juice",
        "width": "300",
        "height": "600",
        "accountId": "dc60ad3d-3e23-4ef1-9e08-afba82212956",
        "accountName": "Nature",
        "dimension": "300x600",
        "device": "0",
        "ad_for": "nexd",
        "ad_type": "Big Reveal",
        "dimensionId": "62",
        "superFormatId": "12",
        "ad_id": "9149cf5d-b063-4d05-8cbc-9c99c2b9535f",
        "creative_id": "ZTECnMK3hbX2fmz8",
        "html_tag": "<ins class=\"adcads\"\r\ndata-click-tracker=\"https://bigads.co\"\r\ndata-debug=\"true\"\r\ndata-has-desktop=\"yes\"\r\ndata-preview-site=\"true\"\r\ndata-settings=\"https://data-apse1.nexd.com/ads/creatives/ZTECnMK3hbX2fmz8/settings.json?c8c5f61e3a5b58405fd80d2eea9545c0a4a1def2\"\r\ndata-stay-in-container=\"true\"\r\ndata-tracking=\"no\"\r\ndata-trackingjs=\"no\"\r\ndata-unit=\"ZTECnMK3hbX2fmz8\"\r\ndata-url=\"https://data-apse1.nexd.com/ads/creatives/\">\r\n<script src=\"https://cdn.nexd.com/frmwrk/teele-release-v5.9.31.js\" type=\"text/javascript\" async></script>\r\n</ins>",
        "refName": "Ocean Spray",
        "default_landingURL": "https://bigads.co",
        "createAt": "2023-05-07 07:32:30",
        "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49",
        "content": [
            {
                "imageSrc": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/6457540de8d1455f3068fa81/1 (1).png",
                "createAt": "2023-05-07 07:32:30",
                "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49"
            }
        ],
        "tagRequested": "true",
        "tagRequestedTime": "2023-05-07 07:32:30",
        "scripts": {
            //eslint-disable-next-line
            "secureScript": "<ins class=\"adcads\"\r\n\tdata-adc-id=\"ALOcXiARf3KF\"\r\n\tdata-unit=\"ALOcXiARf3KF\"\r\n\tdata-clickable=\"yes\"\r\n\tdata-redir=\"yes\"\r\n\tdata-click-tracker=\"${CLICK_URL}https://bigads.co\"\r\n\tdata-click-macro=\"${CLICK_URL}\"\r\n\tdata-has-desktop=\"yes\"\r\n\tdata-responsive=\"yes\"\r\n\tdata-width=\"300\"\r\n\tdata-height=\"600\"\r\n\tdata-meta-source-url=\"${SOURCE_URL}\">\r\n\t<script src=\"https://media.adcanvas.com/ALOcXiARf3KF/adtag.js\" type=\"text/javascript\" async></script>\r\n</ins>\r\n",
            "adcId": "6457540de8d1455f3068fa81"
        },
        "status": {
            "ad_live": true
        },
        "ad_server": "nexd",
        "format_type": "Infeed",
        "creative_number": 1
    },
    {
        "_id": "6457537e4ef20d6f92219d51",
        "ad_name": "Ocean Spray Healthy Drink",
        "width": "300",
        "height": "600",
        "accountId": "dc60ad3d-3e23-4ef1-9e08-afba82212956",
        "accountName": "Nature",
        "dimension": "300x600",
        "device": "0",
        "ad_for": "nexd",
        "ad_type": "Limelight",
        "dimensionId": "64",
        "superFormatId": "19",
        "ad_id": "9149cf5d-b063-4d05-8cbc-9c99c2b9535f",
        "creative_id": "JmRyUGAVB41JAWU6",
        "html_tag": "<ins class=\"adcads\"\r\ndata-click-tracker=\"https://bigads.co\"\r\ndata-debug=\"true\"\r\ndata-has-desktop=\"yes\"\r\ndata-preview-site=\"true\"\r\ndata-settings=\"https://data-apse1.nexd.com/ads/creatives/JmRyUGAVB41JAWU6/settings.json?a2c117e586b1260a4f7ca1e5ce511009c5f5c26d\"\r\ndata-stay-in-container=\"true\"\r\ndata-tracking=\"no\"\r\ndata-trackingjs=\"no\"\r\ndata-unit=\"JmRyUGAVB41JAWU6\"\r\ndata-url=\"https://data-apse1.nexd.com/ads/creatives/\">\r\n<script src=\"https://cdn.nexd.com/frmwrk/teele-release-v5.9.31.js\" type=\"text/javascript\" async></script>\r\n</ins>",
        "refName": "Ocean Spray",
        "default_landingURL": "https://bigads.co",
        "createAt": "2023-05-07 07:30:06",
        "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49",
        "content": [
            {
                "imageSrc": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/6457537e4ef20d6f92219d51/1 (1).png",
                "createAt": "2023-05-07 07:30:06",
                "createBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49"
            }
        ],
        "tagRequested": "true",
        "tagRequestedTime": "2023-05-07 07:30:06",
        "scripts": {
            //eslint-disable-next-line
            "secureScript": "<ins class=\"adcads\"\r\n\tdata-adc-id=\"uw6PD7tU5NoD\"\r\n\tdata-unit=\"uw6PD7tU5NoD\"\r\n\tdata-clickable=\"yes\"\r\n\tdata-redir=\"yes\"\r\n\tdata-click-tracker=\"${CLICK_URL}https://bigads.co\"\r\n\tdata-click-macro=\"${CLICK_URL}\"\r\n\tdata-has-desktop=\"yes\"\r\n\tdata-responsive=\"yes\"\r\n\tdata-width=\"300\"\r\n\tdata-height=\"600\"\r\n\tdata-meta-source-url=\"${SOURCE_URL}\">\r\n\t<script src=\"https://media.adcanvas.com/uw6PD7tU5NoD/adtag.js\" type=\"text/javascript\" async></script>\r\n</ins>\r\n",
            "adcId": "6457537e4ef20d6f92219d51"
        },
        "status": {
            "ad_live": true
        },
        "ad_server": "nexd",
        "format_type": "Infeed",
        "creative_number": 0
    }

];

const media = [
    {
        "id": "6d97a4a2-739f-4afb-8182-dd11d88aa21d",
        "countryId": 15,
        "accountId": "dc60ad3d-3e23-4ef1-9e08-afba82212956",
        "dspId": 2249,
        "currencyCode": "AUD",
        "name": "Run of Network",
        "token": "BigAds-153889",
        "card": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/predefined_media_master/card/55692a92-78b3-4995-99d8-e90d87f827f8/card62789d8bcfce0.jpg",
        "priceFloor": "18",
        "priceModel": "Fixed",
        "mediaType": "Mobile Web, Desktop",
        "description": "Websites and ad slot positions compliant with BIG's ad formats ideal for running with your own targeting",
        "topSites": "[{\"domain\":\"nowtolove.com.au\",\"publisher\":\"ARE MEDIA\",\"adRequests\":\"3480995\",\"integrationMethod\":\"Vendor Marketplace\",\"isOptional\":\"FALSE\"},{\"domain\":\"womensweeklyfood.com.au\",\"publisher\":\"ARE MEDIA\",\"adRequests\":\"2220022\",\"integrationMethod\":\"Vendor Marketplace\",\"isOptional\":\"FALSE\"},{\"domain\":\"who.com.au\",\"publisher\":\"ARE MEDIA\",\"adRequests\":\"1465214\",\"integrationMethod\":\"Vendor Marketplace\",\"isOptional\":\"FALSE\"}]",
        "uniqueVisitors": "19",
        "adRequests": "2490",
        "audienceFact": "100",
        "audienceBehavior": "Australian all age and gender",
        "status": true,
        "createdBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49",
        "createdOn": "2023-05-07 07:24:47+00",
        "updatedOn": null,
        "updatedBy": null,
        "dealTypeId": "55946cb4-00d4-40ee-ac5e-1d01023fd9b1",
        "jobStatus": "Incoming",
        "numberOfSites": "217",
        "type": "Pre-built",
        "live_date": "2023-05-07",
        "brief_date": "2023-05-07",
        "master_template_id": "55692a92-78b3-4995-99d8-e90d87f827f8",
        "internalNotes": null,
        "dealName": "Staging-AU-RON-PREM-2850832 : Buddy - DV3 - 2850832",
        "dspBuyerId": "2850832",
        "supplyPlatform": "Mediagrid-150979"
    }
];

const addons = [{    
    "id": 45,
    "description": "<p><strong>What is AI Alpha? </strong></p>\r\n<p>AI Alpha is an advanced optimisation model, utilising more signals and implementing bespoke strategies, AI Alpha optimises each of your campaigns to meet their unique objectives, unlike the usual one-size-fits-all solutions.</p>\r\n<p><strong>What factors does AI Alpha take into account?</strong></p>\r\n<p>AI Alpha factors in the following:</p>\r\n<p>\u2022\tThe stage in the marketing funnel, from your brief</p>\r\n<p>\u2022\tThe intricacy of the creative message, from Big's Creative Assessment</p>\r\n<p>\u2022\tThe priming effect of the media used, from Criteo</p>\r\n<p>\u2022\tThe achievement of the client's specific goals, from your feedback</p>\r\n<p>\u2022\tAttention Time Metric, from Amplified Intelligence</p>\r\n<p></p>",
    "name": "AI Alpha",
    "card": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/addons/bespoke/card/45/card66eb9d61b6b6d.png",
    "vendorName": "Amplified Intelligence",
    "logo": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/addons/bespoke/logo/45/logo66eb9d61c672b.png",
    "metrics": "7",
    "optimisation": true,
    "currencyCode": "AUD",
    "price": "3",
    "dspId_negate": "undefined",
    "countryId": "15",
    "dealTypeId": "55946cb4-00d4-40ee-ac5e-1d01023fd9b1,e7452996-745c-47dc-a967-451388a99d5e,e9afb4af-9a57-4ca4-ab6a-86e124ade1b2,39397939-4c02-4b8d-83a6-9f3bc6e1223a",
    "status": true,
    "createdBy": "98cf7f45-5b68-46e6-8b02-240c02b1ae49",
    "createdOn": "2024-09-19 03:41:21+00",
    "updatedOn": "2024-09-19 03:49:27+00",
    "subtype": "Attention Metrics",
    "bundled_addons": "[]",
    "bundled_discount": "0.00",
    "price_model": "Fixed",
    "brief_admin": false,
    "fee": null,
    "decarbonise": false
}]

const dealInfo = {
    "id": "9149cf5d-b063-4d05-8cbc-9c99c2b9535f",
    "accountId": "",
    "accountName": "Nature",
    "networkName": "Nature",
    "name": "Ocean Spray",
    "decarbonise": "on",
    "measure_emissions": true,
    "dspId": 2249,
    "is_mobile_app": false,
    "dealType": "CCM",
    "createdBy": "admin",
    "createdOn": "2023-04-19 10:04:12",
    "updatedOn": Date.now(),
    "selectedMedias": "nature-medias",
    "status": 1,
    "ext_campaign_id_n": "nowhere",
    "ext_campaign_id_a": "nowhere",
    "userName": "Admin",
    "isDemo": false,
    addons: addons,
    "addon_id": 45,
    "decarbonisation_option": 1,
    "decarbonise_options": "{\"format_category\":true,\"addons\":true,\"media\":true,\"addon_emission_selected\":0,\"max_addon_emission\":0,\"media_emission_selected\":350,\"max_media_emission\":350}",
    channel: "Rich Media"
}

export const MyDealsPageDataCo2 = {

    ...dealInfo,
    "creative": {
        "count": 2,
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/creative/6457537e4ef20d6f92219d51/1 (1).png"
    },
    "curated-media": {
        "count": 1,
        "type": "Pre-built"
    },
    "briefs": null,
    "slug_name": "dbm",
    "dsp": "Google Display & Video 360",
    "format_type": {
        "id": "55946cb4-00d4-40ee-ac5e-1d01023fd9b1",
        "borderColor": "#1011ea",
        "icon": null,
        "name": "Premium",
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/deal_type/image/55946cb4-00d4-40ee-ac5e-1d01023fd9b1/Premium.jpeg"
    },
    "is_tnc_accepted": true,

}


export const GetCuratedAdCo2 = {
    "page-info": [
        {
            ...dealInfo,
            "createdByName": "Admin",
            "termsConditionsUrl": null,

        }
    ],
    "creative": creative,
    "curated-media": media,
    "briefs": null,
    "slug_name": "dbm",
    "updatedOn": Date.now(),
    "dsp": "Google Display & Video 360",
    "macros": {
        // eslint-disable-next-line 
        "click_url": "${CLICK_URL}",
        // eslint-disable-next-line 
        "cachebuster": "${CACHEBUSTER}"
    },
    "format_type": {
        "id": "55946cb4-00d4-40ee-ac5e-1d01023fd9b1",
        "borderColor": "#1011ea",
        "icon": null,
        "name": "Premium",
        "image": "https://s3-ap-southeast-2.amazonaws.com/library.bigbuddy.io/devBuddy/deal_type/image/55946cb4-00d4-40ee-ac5e-1d01023fd9b1/Premium.jpeg"
    },
    dealTypeInfo: {
        name: "Premium"
    },
    addons: addons

}

export const ActivityReportCo2 = {
    "result": [
        {
            "day": "2021-12-01",
            "impressions": "78248",
            "measurables": "77466",
            "viewables": "69965",
            "interactionsTime": "0",
            "engagements": "1101",
            "clicks": "573",
            "viewabilityRate": "90.32",
            "engagementRate": "1.41",
            "ctr": "0.73"
        },
        {
            "day": "2021-12-02",
            "impressions": "72531",
            "measurables": "71806",
            "viewables": "66399",
            "interactionsTime": "0",
            "engagements": "1033",
            "clicks": "671",
            "viewabilityRate": "92.47",
            "engagementRate": "1.42",
            "ctr": "0.93"
        },
        {
            "day": "2021-12-03",
            "impressions": "62219",
            "measurables": "61597",
            "viewables": "54989",
            "interactionsTime": "0",
            "engagements": "1161",
            "clicks": "619",
            "viewabilityRate": "89.27",
            "engagementRate": "1.87",
            "ctr": "0.99"
        },
        {
            "day": "2021-12-04",
            "impressions": "76411",
            "measurables": "75647",
            "viewables": "69409",
            "interactionsTime": "0",
            "engagements": "1449",
            "clicks": "583",
            "viewabilityRate": "91.75",
            "engagementRate": "1.90",
            "ctr": "0.76"
        },
        {
            "day": "2021-12-05",
            "impressions": "52958",
            "measurables": "52428",
            "viewables": "47125",
            "interactionsTime": "0",
            "engagements": "978",
            "clicks": "479",
            "viewabilityRate": "89.88",
            "engagementRate": "1.85",
            "ctr": "0.90"
        },
        {
            "day": "2021-12-06",
            "impressions": "57087",
            "measurables": "56516",
            "viewables": "52319",
            "interactionsTime": "0",
            "engagements": "802",
            "clicks": "558",
            "viewabilityRate": "92.57",
            "engagementRate": "1.40",
            "ctr": "0.98"
        },
        {
            "day": "2021-12-07",
            "impressions": "61625",
            "measurables": "61009",
            "viewables": "53566",
            "interactionsTime": "0",
            "engagements": "934",
            "clicks": "554",
            "viewabilityRate": "87.80",
            "engagementRate": "1.52",
            "ctr": "0.90"
        },
        {
            "day": "2021-12-08",
            "impressions": "70737",
            "measurables": "70030",
            "viewables": "63543",
            "interactionsTime": "0",
            "engagements": "1030",
            "clicks": "518",
            "viewabilityRate": "90.74",
            "engagementRate": "1.46",
            "ctr": "0.73"
        },
        {
            "day": "2021-12-09",
            "impressions": "49858",
            "measurables": "49359",
            "viewables": "43377",
            "interactionsTime": "0",
            "engagements": "774",
            "clicks": "391",
            "viewabilityRate": "87.88",
            "engagementRate": "1.55",
            "ctr": "0.78"
        },
        {
            "day": "2021-12-10",
            "impressions": "59902",
            "measurables": "59303",
            "viewables": "54222",
            "interactionsTime": "0",
            "engagements": "919",
            "clicks": "604",
            "viewabilityRate": "91.43",
            "engagementRate": "1.53",
            "ctr": "1.01"
        },
        {
            "day": "2021-12-11",
            "impressions": "72217",
            "measurables": "71495",
            "viewables": "63055",
            "interactionsTime": "0",
            "engagements": "1401",
            "clicks": "711",
            "viewabilityRate": "88.20",
            "engagementRate": "1.94",
            "ctr": "0.98"
        },
        {
            "day": "2021-12-12",
            "impressions": "54081",
            "measurables": "53540",
            "viewables": "48049",
            "interactionsTime": "0",
            "engagements": "706",
            "clicks": "481",
            "viewabilityRate": "89.74",
            "engagementRate": "1.31",
            "ctr": "0.89"
        },
        {
            "day": "2021-12-13",
            "impressions": "68067",
            "measurables": "67386",
            "viewables": "60086",
            "interactionsTime": "0",
            "engagements": "1047",
            "clicks": "698",
            "viewabilityRate": "89.17",
            "engagementRate": "1.54",
            "ctr": "1.03"
        },
        {
            "day": "2021-12-14",
            "impressions": "71911",
            "measurables": "71192",
            "viewables": "62630",
            "interactionsTime": "0",
            "engagements": "1140",
            "clicks": "545",
            "viewabilityRate": "87.97",
            "engagementRate": "1.59",
            "ctr": "0.76"
        },
        {
            "day": "2021-12-15",
            "impressions": "81042",
            "measurables": "80232",
            "viewables": "72713",
            "interactionsTime": "0",
            "engagements": "1293",
            "clicks": "673",
            "viewabilityRate": "90.63",
            "engagementRate": "1.60",
            "ctr": "0.83"
        },
        {
            "day": "2021-12-16",
            "impressions": "72391",
            "measurables": "71667",
            "viewables": "65255",
            "interactionsTime": "0",
            "engagements": "1384",
            "clicks": "604",
            "viewabilityRate": "91.05",
            "engagementRate": "1.91",
            "ctr": "0.83"
        },
        {
            "day": "2021-12-17",
            "impressions": "72414",
            "measurables": "71690",
            "viewables": "63457",
            "interactionsTime": "0",
            "engagements": "989",
            "clicks": "729",
            "viewabilityRate": "88.52",
            "engagementRate": "1.37",
            "ctr": "1.01"
        },
        {
            "day": "2021-12-18",
            "impressions": "53345",
            "measurables": "52812",
            "viewables": "47116",
            "interactionsTime": "0",
            "engagements": "975",
            "clicks": "365",
            "viewabilityRate": "89.22",
            "engagementRate": "1.83",
            "ctr": "0.68"
        },
        {
            "day": "2021-12-19",
            "impressions": "60872",
            "measurables": "60263",
            "viewables": "54664",
            "interactionsTime": "0",
            "engagements": "1020",
            "clicks": "567",
            "viewabilityRate": "90.71",
            "engagementRate": "1.68",
            "ctr": "0.93"
        },
        {
            "day": "2021-12-20",
            "impressions": "71899",
            "measurables": "71180",
            "viewables": "64497",
            "interactionsTime": "0",
            "engagements": "1057",
            "clicks": "612",
            "viewabilityRate": "90.61",
            "engagementRate": "1.47",
            "ctr": "0.85"
        },
        {
            "day": "2021-12-21",
            "impressions": "54316",
            "measurables": "53773",
            "viewables": "48816",
            "interactionsTime": "0",
            "engagements": "858",
            "clicks": "546",
            "viewabilityRate": "90.78",
            "engagementRate": "1.58",
            "ctr": "1.01"
        },
        {
            "day": "2021-12-22",
            "impressions": "76199",
            "measurables": "75437",
            "viewables": "68429",
            "interactionsTime": "0",
            "engagements": "1176",
            "clicks": "686",
            "viewabilityRate": "90.71",
            "engagementRate": "1.54",
            "ctr": "0.90"
        },
        {
            "day": "2021-12-23",
            "impressions": "68628",
            "measurables": "67942",
            "viewables": "60069",
            "interactionsTime": "0",
            "engagements": "1078",
            "clicks": "568",
            "viewabilityRate": "88.41",
            "engagementRate": "1.57",
            "ctr": "0.83"
        },
        {
            "day": "2021-12-24",
            "impressions": "61699",
            "measurables": "61082",
            "viewables": "54028",
            "interactionsTime": "0",
            "engagements": "1122",
            "clicks": "464",
            "viewabilityRate": "88.45",
            "engagementRate": "1.82",
            "ctr": "0.75"
        },
        {
            "day": "2021-12-25",
            "impressions": "84717",
            "measurables": "83870",
            "viewables": "76497",
            "interactionsTime": "0",
            "engagements": "1466",
            "clicks": "803",
            "viewabilityRate": "91.21",
            "engagementRate": "1.73",
            "ctr": "0.95"
        },
        {
            "day": "2021-12-26",
            "impressions": "55888",
            "measurables": "55329",
            "viewables": "51262",
            "interactionsTime": "0",
            "engagements": "751",
            "clicks": "416",
            "viewabilityRate": "92.65",
            "engagementRate": "1.34",
            "ctr": "0.74"
        },
        {
            "day": "2021-12-27",
            "impressions": "76809",
            "measurables": "76041",
            "viewables": "70684",
            "interactionsTime": "0",
            "engagements": "1332",
            "clicks": "633",
            "viewabilityRate": "92.96",
            "engagementRate": "1.73",
            "ctr": "0.82"
        },
        {
            "day": "2021-12-28",
            "impressions": "89338",
            "measurables": "88445",
            "viewables": "80491",
            "interactionsTime": "0",
            "engagements": "1289",
            "clicks": "901",
            "viewabilityRate": "91.01",
            "engagementRate": "1.44",
            "ctr": "1.01"
        },
        {
            "day": "2021-12-29",
            "impressions": "52080",
            "measurables": "51559",
            "viewables": "45893",
            "interactionsTime": "0",
            "engagements": "912",
            "clicks": "437",
            "viewabilityRate": "89.01",
            "engagementRate": "1.75",
            "ctr": "0.84"
        },
        {
            "day": "2021-12-30",
            "impressions": "72832",
            "measurables": "72104",
            "viewables": "64510",
            "interactionsTime": "0",
            "engagements": "1390",
            "clicks": "670",
            "viewabilityRate": "89.47",
            "engagementRate": "1.91",
            "ctr": "0.92"
        },
        {
            "day": "2021-12-31",
            "impressions": "84848",
            "measurables": "84000",
            "viewables": "76011",
            "interactionsTime": "0",
            "engagements": "1605",
            "clicks": "618",
            "viewabilityRate": "90.49",
            "engagementRate": "1.89",
            "ctr": "0.73"
        }
    ],
    "summary": {
        "impressions": "2097169",
        "measurables": "2076197",
        "viewables": "1873126",
        "interactionsTime": 0,
        "engagements": "34172",
        "clicks": "18277",
        "viewabilityRate": 90.22,
        "engagementRate": 1.63,
        "ctr": 0.87
    },
    "errors": [],
    "withCreativeBreakdown": [
        {
            "creativeName": "Ocean Spray Healthy Juice",
            "impressions": 1824988,
            "measurables": 1806738,
            "viewables": 1696914,
            "interactionsTime": 0,
            "engagements": 31433,
            "clicks": 17339,
            "viewabilityRate": 93.92,
            "engagementRate": 1.17,
            "ctr": 0.95,
            "avgEngagedTime": 5.9
        },
        {
            "creativeName": "Ocean Spray Healthy Drink",
            "impressions": 272181,
            "measurables": 269459,
            "viewables": 176212,
            "interactionsTime": 0,
            "engagements": 2739,
            "clicks": 938,
            "viewabilityRate": 65.39,
            "engagementRate": 1.01,
            "ctr": 0.34,
            "avgEngagedTime": 4.1
        }
    ],
    "withSizeBreakdown": [
        {
            "size": "300x600",
            "impressions": 2097169,
            "measurables": 2076197,
            "viewables": 1873126,
            "interactionsTime": 7263,
            "engagements": 34172,
            "clicks": 18277,
            "viewabilityRate": 90.22,
            "engagementRate": 1.63,
            "ctr": 0.87,
            "avgEngagedTime": 5
        }
    ],
    "attentionScore": {
        "success": true,
        "data": {
            "publishers": [
                {
                    "domain": "brainly.co.id",
                    "impressions": 8532,
                    "apm": 3.8,
                    "avgActiveAttention": 0.34,
                    "avgPassiveAttention": 3.46,
                    "avgTotalAttention": 3.8
                },
                {
                    "domain": "www.cnbcindonesia.com",
                    "impressions": 5579,
                    "apm": 3.94,
                    "avgActiveAttention": 0.4,
                    "avgPassiveAttention": 3.54,
                    "avgTotalAttention": 3.94
                },
                {
                    "domain": "news.detik.com",
                    "impressions": 5499,
                    "apm": 3.92,
                    "avgActiveAttention": 0.38,
                    "avgPassiveAttention": 3.54,
                    "avgTotalAttention": 3.92
                },
                {
                    "domain": "mail.yahoo.com",
                    "impressions": 3309,
                    "apm": 3.8,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.47,
                    "avgTotalAttention": 3.8
                },
                {
                    "domain": "portalsulut.pikiran-rakyat.com",
                    "impressions": 3181,
                    "apm": 3.86,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.54,
                    "avgTotalAttention": 3.86
                },
                {
                    "domain": "sport.detik.com",
                    "impressions": 3087,
                    "apm": 3.72,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.35,
                    "avgTotalAttention": 3.72
                },
                {
                    "domain": "www.indosport.com",
                    "impressions": 2464,
                    "apm": 3.9,
                    "avgActiveAttention": 0.34,
                    "avgPassiveAttention": 3.56,
                    "avgTotalAttention": 3.9
                },
                {
                    "domain": "zonajakarta.pikiran-rakyat.com",
                    "impressions": 2194,
                    "apm": 3.79,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.47,
                    "avgTotalAttention": 3.79
                },
                {
                    "domain": "wartaekonomi.co.id",
                    "impressions": 2155,
                    "apm": 3.79,
                    "avgActiveAttention": 0.34,
                    "avgPassiveAttention": 3.45,
                    "avgTotalAttention": 3.79
                },
                {
                    "domain": "deskjabar.pikiran-rakyat.com",
                    "impressions": 2112,
                    "apm": 3.89,
                    "avgActiveAttention": 0.36,
                    "avgPassiveAttention": 3.53,
                    "avgTotalAttention": 3.89
                },
                {
                    "domain": "www.google.com",
                    "impressions": 1783,
                    "apm": 3.98,
                    "avgActiveAttention": 0.4,
                    "avgPassiveAttention": 3.58,
                    "avgTotalAttention": 3.98
                },
                {
                    "domain": "www.99.co",
                    "impressions": 1731,
                    "apm": 3.85,
                    "avgActiveAttention": 0.36,
                    "avgPassiveAttention": 3.49,
                    "avgTotalAttention": 3.85
                },
                {
                    "domain": "9gag.com",
                    "impressions": 1656,
                    "apm": 3.78,
                    "avgActiveAttention": 0.36,
                    "avgPassiveAttention": 3.42,
                    "avgTotalAttention": 3.78
                },
                {
                    "domain": "www.cnnindonesia.com",
                    "impressions": 1501,
                    "apm": 3.9,
                    "avgActiveAttention": 0.39,
                    "avgPassiveAttention": 3.51,
                    "avgTotalAttention": 3.9
                },
                {
                    "domain": "www.dailymail.co.uk",
                    "impressions": 1340,
                    "apm": 4.06,
                    "avgActiveAttention": 0.39,
                    "avgPassiveAttention": 3.67,
                    "avgTotalAttention": 4.06
                },
                {
                    "domain": "tirto.id",
                    "impressions": 1318,
                    "apm": 3.94,
                    "avgActiveAttention": 0.34,
                    "avgPassiveAttention": 3.6,
                    "avgTotalAttention": 3.94
                },
                {
                    "domain": "finance.detik.com",
                    "impressions": 1129,
                    "apm": 3.87,
                    "avgActiveAttention": 0.4,
                    "avgPassiveAttention": 3.47,
                    "avgTotalAttention": 3.87
                },
                {
                    "domain": "www.hops.id",
                    "impressions": 1032,
                    "apm": 3.87,
                    "avgActiveAttention": 0.4,
                    "avgPassiveAttention": 3.47,
                    "avgTotalAttention": 3.87
                },
                {
                    "domain": "www.haibunda.com",
                    "impressions": 1021,
                    "apm": 3.98,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.66,
                    "avgTotalAttention": 3.98
                },
                {
                    "domain": "potensibisnis.pikiran-rakyat.com",
                    "impressions": 982,
                    "apm": 3.77,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.44,
                    "avgTotalAttention": 3.77
                },
                {
                    "domain": "m.jpnn.com",
                    "impressions": 961,
                    "apm": 3.73,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.36,
                    "avgTotalAttention": 3.73
                },
                {
                    "domain": "portaljember.pikiran-rakyat.com",
                    "impressions": 941,
                    "apm": 3.86,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.53,
                    "avgTotalAttention": 3.86
                },
                {
                    "domain": "wolipop.detik.com",
                    "impressions": 827,
                    "apm": 3.91,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.54,
                    "avgTotalAttention": 3.91
                },
                {
                    "domain": "apps.facebook.com",
                    "impressions": 780,
                    "apm": 4.05,
                    "avgActiveAttention": 0.4,
                    "avgPassiveAttention": 3.65,
                    "avgTotalAttention": 4.05
                },
                {
                    "domain": "id.soccerway.com",
                    "impressions": 767,
                    "apm": 3.9,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.57,
                    "avgTotalAttention": 3.9
                },
                {
                    "domain": "i.mangaowls.com",
                    "impressions": 750,
                    "apm": 3.82,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.45,
                    "avgTotalAttention": 3.82
                },
                {
                    "domain": "www-detik-com.cdn.ampproject.org",
                    "impressions": 693,
                    "apm": 3.93,
                    "avgActiveAttention": 0.34,
                    "avgPassiveAttention": 3.59,
                    "avgTotalAttention": 3.93
                },
                {
                    "domain": "hot.detik.com",
                    "impressions": 679,
                    "apm": 3.73,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.4,
                    "avgTotalAttention": 3.73
                },
                {
                    "domain": "mapaybandung.pikiran-rakyat.com",
                    "impressions": 670,
                    "apm": 3.9,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.53,
                    "avgTotalAttention": 3.9
                },
                {
                    "domain": "m.dream.co.id",
                    "impressions": 656,
                    "apm": 3.99,
                    "avgActiveAttention": 0.4,
                    "avgPassiveAttention": 3.59,
                    "avgTotalAttention": 3.99
                },
                {
                    "domain": "populis.id",
                    "impressions": 640,
                    "apm": 3.81,
                    "avgActiveAttention": 0.34,
                    "avgPassiveAttention": 3.47,
                    "avgTotalAttention": 3.81
                },
                {
                    "domain": "www.onlinedoctranslator.com",
                    "impressions": 619,
                    "apm": 3.71,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.34,
                    "avgTotalAttention": 3.71
                },
                {
                    "domain": "news-detik-com.cdn.ampproject.org",
                    "impressions": 617,
                    "apm": 3.94,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.62,
                    "avgTotalAttention": 3.94
                },
                {
                    "domain": "jurnalsoreang.pikiran-rakyat.com",
                    "impressions": 580,
                    "apm": 4.05,
                    "avgActiveAttention": 0.38,
                    "avgPassiveAttention": 3.67,
                    "avgTotalAttention": 4.05
                },
                {
                    "domain": "m.bola.com",
                    "impressions": 579,
                    "apm": 3.94,
                    "avgActiveAttention": 0.38,
                    "avgPassiveAttention": 3.56,
                    "avgTotalAttention": 3.94
                },
                {
                    "domain": "travel.detik.com",
                    "impressions": 545,
                    "apm": 3.94,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.57,
                    "avgTotalAttention": 3.94
                },
                {
                    "domain": "beritadiy.pikiran-rakyat.com",
                    "impressions": 538,
                    "apm": 3.86,
                    "avgActiveAttention": 0.36,
                    "avgPassiveAttention": 3.5,
                    "avgTotalAttention": 3.86
                },
                {
                    "domain": "portalpekalongan.pikiran-rakyat.com",
                    "impressions": 525,
                    "apm": 4.02,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.65,
                    "avgTotalAttention": 4.02
                },
                {
                    "domain": "www.freepik.com",
                    "impressions": 516,
                    "apm": 3.85,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.48,
                    "avgTotalAttention": 3.85
                },
                {
                    "domain": "www.radio-australia.org",
                    "impressions": 483,
                    "apm": 3.69,
                    "avgActiveAttention": 0.38,
                    "avgPassiveAttention": 3.31,
                    "avgTotalAttention": 3.69
                },
                {
                    "domain": "inet.detik.com",
                    "impressions": 461,
                    "apm": 3.74,
                    "avgActiveAttention": 0.39,
                    "avgPassiveAttention": 3.35,
                    "avgTotalAttention": 3.74
                },
                {
                    "domain": "game8.co",
                    "impressions": 445,
                    "apm": 3.64,
                    "avgActiveAttention": 0.35,
                    "avgPassiveAttention": 3.29,
                    "avgTotalAttention": 3.64
                },
                {
                    "domain": "ringtimesbali.pikiran-rakyat.com",
                    "impressions": 421,
                    "apm": 4.03,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.66,
                    "avgTotalAttention": 4.03
                },
                {
                    "domain": "www.goal.com",
                    "impressions": 394,
                    "apm": 3.94,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.61,
                    "avgTotalAttention": 3.94
                },
                {
                    "domain": "m-republika-co-id.cdn.ampproject.org",
                    "impressions": 389,
                    "apm": 3.83,
                    "avgActiveAttention": 0.38,
                    "avgPassiveAttention": 3.45,
                    "avgTotalAttention": 3.83
                },
                {
                    "domain": "www.popbela.com",
                    "impressions": 385,
                    "apm": 3.94,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.61,
                    "avgTotalAttention": 3.94
                },
                {
                    "domain": "international.sindonews.com",
                    "impressions": 368,
                    "apm": 3.74,
                    "avgActiveAttention": 0.38,
                    "avgPassiveAttention": 3.36,
                    "avgTotalAttention": 3.74
                },
                {
                    "domain": "m.gsmarena.com",
                    "impressions": 342,
                    "apm": 3.8,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.43,
                    "avgTotalAttention": 3.8
                },
                {
                    "domain": "www.sofascore.com",
                    "impressions": 340,
                    "apm": 4.04,
                    "avgActiveAttention": 0.38,
                    "avgPassiveAttention": 3.66,
                    "avgTotalAttention": 4.04
                },
                {
                    "domain": "www.dailymotion.com",
                    "impressions": 338,
                    "apm": 3.78,
                    "avgActiveAttention": 0.36,
                    "avgPassiveAttention": 3.42,
                    "avgTotalAttention": 3.78
                }
            ],
            "device_type": [{
                'device_type': 'Desktop',
                'impressions': 15,
                'apm': 3.64,
                'avgActiveAttention': 0.35,
                'avgPassiveAttention': 3.29,
                'avgTotalAttention': 3.64
            },
            {
                'device_type': 'Phone',
                'impressions': 13,
                'apm': 3.88,
                'avgActiveAttention': 0.33,
                'avgPassiveAttention': 3.55,
                'avgTotalAttention': 3.88
            },
            {
                'device_type': 'Tablet',
                'impressions': 10,
                'apm': 3.96,
                'avgActiveAttention': 0.39,
                'avgPassiveAttention': 3.57,
                'avgTotalAttention': 3.96
            }],
            "daily": [
                {
                    "date": "2021-12-01",
                    "impressions": 5860,
                    "apm": 3.52,
                    "avgActiveAttention": 0.28,
                    "avgPassiveAttention": 3.24,
                    "avgTotalAttention": 3.52
                },
                {
                    "date": "2021-12-02",
                    "impressions": 5254,
                    "apm": 3.54,
                    "avgActiveAttention": 0.3,
                    "avgPassiveAttention": 3.24,
                    "avgTotalAttention": 3.54
                },
                {
                    "date": "2021-12-03",
                    "impressions": 4961,
                    "apm": 3.52,
                    "avgActiveAttention": 0.3,
                    "avgPassiveAttention": 3.22,
                    "avgTotalAttention": 3.52
                },
                {
                    "date": "2021-12-04",
                    "impressions": 4750,
                    "apm": 3.51,
                    "avgActiveAttention": 0.3,
                    "avgPassiveAttention": 3.21,
                    "avgTotalAttention": 3.51
                },
                {
                    "date": "2021-12-05",
                    "impressions": 4928,
                    "apm": 3.59,
                    "avgActiveAttention": 0.3,
                    "avgPassiveAttention": 3.29,
                    "avgTotalAttention": 3.59
                },
                {
                    "date": "2021-12-06",
                    "impressions": 4335,
                    "apm": 3.51,
                    "avgActiveAttention": 0.28,
                    "avgPassiveAttention": 3.23,
                    "avgTotalAttention": 3.51
                },
                {
                    "date": "2021-12-07",
                    "impressions": 5282,
                    "apm": 3.52,
                    "avgActiveAttention": 0.28,
                    "avgPassiveAttention": 3.24,
                    "avgTotalAttention": 3.52
                },
                {
                    "date": "2021-12-08",
                    "impressions": 4820,
                    "apm": 3.48,
                    "avgActiveAttention": 0.28,
                    "avgPassiveAttention": 3.2,
                    "avgTotalAttention": 3.48
                },
                {
                    "date": "2021-12-09",
                    "impressions": 4229,
                    "apm": 3.52,
                    "avgActiveAttention": 0.29,
                    "avgPassiveAttention": 3.23,
                    "avgTotalAttention": 3.52
                },
                {
                    "date": "2021-12-10",
                    "impressions": 4423,
                    "apm": 3.6,
                    "avgActiveAttention": 0.3,
                    "avgPassiveAttention": 3.3,
                    "avgTotalAttention": 3.6
                },
                {
                    "date": "2021-12-11",
                    "impressions": 5678,
                    "apm": 3.72,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.4,
                    "avgTotalAttention": 3.72
                },
                {
                    "date": "2021-12-12",
                    "impressions": 4487,
                    "apm": 3.71,
                    "avgActiveAttention": 0.31,
                    "avgPassiveAttention": 3.4,
                    "avgTotalAttention": 3.71
                },
                {
                    "date": "2021-12-13",
                    "impressions": 4869,
                    "apm": 3.66,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.34,
                    "avgTotalAttention": 3.66
                },
                {
                    "date": "2021-12-14",
                    "impressions": 5609,
                    "apm": 3.68,
                    "avgActiveAttention": 0.31,
                    "avgPassiveAttention": 3.37,
                    "avgTotalAttention": 3.68
                },
                {
                    "date": "2021-12-15",
                    "impressions": 5618,
                    "apm": 3.69,
                    "avgActiveAttention": 0.31,
                    "avgPassiveAttention": 3.38,
                    "avgTotalAttention": 3.69
                },
                {
                    "date": "2021-12-16",
                    "impressions": 4868,
                    "apm": 3.69,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.37,
                    "avgTotalAttention": 3.69
                },
                {
                    "date": "2021-12-17",
                    "impressions": 5019,
                    "apm": 3.61,
                    "avgActiveAttention": 0.31,
                    "avgPassiveAttention": 3.3,
                    "avgTotalAttention": 3.61
                },
                {
                    "date": "2021-12-18",
                    "impressions": 4969,
                    "apm": 3.63,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.31,
                    "avgTotalAttention": 3.63
                },
                {
                    "date": "2021-12-19",
                    "impressions": 4624,
                    "apm": 3.66,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.34,
                    "avgTotalAttention": 3.66
                },
                {
                    "date": "2021-12-20",
                    "impressions": 4607,
                    "apm": 3.69,
                    "avgActiveAttention": 0.31,
                    "avgPassiveAttention": 3.38,
                    "avgTotalAttention": 3.69
                },
                {
                    "date": "2021-12-21",
                    "impressions": 4074,
                    "apm": 3.64,
                    "avgActiveAttention": 0.32,
                    "avgPassiveAttention": 3.32,
                    "avgTotalAttention": 3.64
                },
                {
                    "date": "2021-12-22",
                    "impressions": 5930,
                    "apm": 3.78,
                    "avgActiveAttention": 0.35,
                    "avgPassiveAttention": 3.43,
                    "avgTotalAttention": 3.78
                },
                {
                    "date": "2021-12-23",
                    "impressions": 5351,
                    "apm": 3.74,
                    "avgActiveAttention": 0.34,
                    "avgPassiveAttention": 3.4,
                    "avgTotalAttention": 3.74
                },
                {
                    "date": "2021-12-24",
                    "impressions": 4318,
                    "apm": 3.79,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.46,
                    "avgTotalAttention": 3.79
                },
                {
                    "date": "2021-12-25",
                    "impressions": 5095,
                    "apm": 3.76,
                    "avgActiveAttention": 0.36,
                    "avgPassiveAttention": 3.4,
                    "avgTotalAttention": 3.76
                },
                {
                    "date": "2021-12-26",
                    "impressions": 4288,
                    "apm": 3.77,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.44,
                    "avgTotalAttention": 3.77
                },
                {
                    "date": "2021-12-27",
                    "impressions": 5143,
                    "apm": 3.79,
                    "avgActiveAttention": 0.35,
                    "avgPassiveAttention": 3.44,
                    "avgTotalAttention": 3.79
                },
                {
                    "date": "2021-12-28",
                    "impressions": 6162,
                    "apm": 3.78,
                    "avgActiveAttention": 0.35,
                    "avgPassiveAttention": 3.43,
                    "avgTotalAttention": 3.78
                },
                {
                    "date": "2021-12-29",
                    "impressions": 4131,
                    "apm": 3.82,
                    "avgActiveAttention": 0.36,
                    "avgPassiveAttention": 3.46,
                    "avgTotalAttention": 3.82
                },
                {
                    "date": "2021-12-30",
                    "impressions": 4704,
                    "apm": 3.75,
                    "avgActiveAttention": 0.33,
                    "avgPassiveAttention": 3.42,
                    "avgTotalAttention": 3.75
                },
                {
                    "date": "2021-12-31",
                    "impressions": 6011,
                    "apm": 3.8,
                    "avgActiveAttention": 0.35,
                    "avgPassiveAttention": 3.45,
                    "avgTotalAttention": 3.8
                }
            ],
            "creatives": [
                {
                    "name": "Ocean Spray Healthy Drink",
                    "impressions": 95069,
                    "apm": 3.66,
                    "total_view_time": 347953,
                    "avgActiveAttention": 0.34,
                    "avgPassiveAttention": 3.32,
                    "avgTotalAttention": 3.66
                },
                {
                    "name": "Ocean Spray Healthy Juice ",
                    "impressions": 59329,
                    "apm": 3.89,
                    "total_view_time": 230790,
                    "avgActiveAttention": 0.38,
                    "avgPassiveAttention": 3.51,
                    "avgTotalAttention": 3.89
                }
            ],
            "summary": [
                {
                    "impressions": 154389,
                    "apm": 3.85,
                    "total_view_time": 594432,
                    "avgActiveAttention": 0.37,
                    "avgPassiveAttention": 3.48,
                    "avgTotalAttention": 3.85,
                    "impressionsActive1s": 95736,
                    "impressionsActive2s": 32262,
                    "impressionsActive3s": 11071,
                    "impressionsActive4s": 5525,
                    "impressionsActive5s": 1109
                }
            ]
        }
    }
}

export const EmissionSummaryData = {
    "total": 12,
    "pre_decarbonisation": 18,
    "carbon_reduction": 6,
    "ad_serving": 3,
    "media": 7,
    "addon": 2,
    "estimated": 395,
    "actual": 264.7,
    'media_distribution': 1.6,
    "ad_selection": 6.6,
    "creative_distribution": 1,
    "total_emission": 40.8,
    "total_con_emission": 28.8,
    "consumer_device": 2.7,
    "creative_con_device": 2.7


}
export const EmissionData = [
    {
        "_id": "6457540de8d1455f3068fa81",
        "name": "Big Reveal",
        "total": 5,
        "pre_decarbonisation": 8,
        "carbon_reduction": 3,
        "ad_serving": 1.2,
        "media": 5.5,
        "addon": 1.1,
        "estimated": 395,
        "actual": 246.9,
        'media_distribution': 0.7,
        "ad_selection": 2.8,
        "creative_distribution": 0.4,
        "total_emission": 17,
        "total_con_emission": 12,
        "consumer_device": 10.9,
        "creative_con_device": 1.1,
        publishers: [
            {
                "name": "brainly.co.id",
                "impressions": 8532,
                "total": 0.619571848,
                "media_distribution": 0.086740059,
                "ad_selection": 0.346960235,
                "creative_distribution": 0.049565748,
                "consumer_device": 0.136305806,
                "is_missing": "FALSE"
            },
            {
                "name": "www.cnbcindonesia.com",
                "impressions": 5579,
                "total": 0.405132599,
                "media_distribution": 0.056718564,
                "ad_selection": 0.226874256,
                "creative_distribution": 0.032410608,
                "consumer_device": 0.089129172,
                "is_missing": "FALSE"
            },
            {
                "name": "news.detik.com",
                "impressions": 5499,
                "total": 0.399323206,
                "media_distribution": 0.055905249,
                "ad_selection": 0.223620995,
                "creative_distribution": 0.031945856,
                "consumer_device": 0.087851105,
                "is_missing": "FALSE"
            },
            {
                "name": "mail.yahoo.com",
                "impressions": 3309,
                "total": 0.240291051,
                "media_distribution": 0.033640747,
                "ad_selection": 0.134562988,
                "creative_distribution": 0.019223284,
                "consumer_device": 0.052864031,
                "is_missing": "FALSE"
            },
            {
                "name": "portalsulut.pikiran-rakyat.com",
                "impressions": 3181,
                "total": 0.230996021,
                "media_distribution": 0.032339443,
                "ad_selection": 0.129357772,
                "creative_distribution": 0.018479682,
                "consumer_device": 0.050819125,
                "is_missing": "FALSE"
            },
            {
                "name": "sport.detik.com",
                "impressions": 3087,
                "total": 0.224169983,
                "media_distribution": 0.031383798,
                "ad_selection": 0.12553519,
                "creative_distribution": 0.017933599,
                "consumer_device": 0.049317396,
                "is_missing": "FALSE"
            },
            {
                "name": "www.indosport.com",
                "impressions": 2464,
                "total": 0.178929329,
                "media_distribution": 0.025050106,
                "ad_selection": 0.100200424,
                "creative_distribution": 0.014314346,
                "consumer_device": 0.039364452,
                "is_missing": "FALSE"
            },
            {
                "name": "zonajakarta.pikiran-rakyat.com",
                "impressions": 2194,
                "total": 0.159322625,
                "media_distribution": 0.022305167,
                "ad_selection": 0.08922067,
                "creative_distribution": 0.01274581,
                "consumer_device": 0.035050977,
                "is_missing": "FALSE"
            },
            {
                "name": "wartaekonomi.co.id",
                "impressions": 2155,
                "total": 0.156490545,
                "media_distribution": 0.021908676,
                "ad_selection": 0.087634705,
                "creative_distribution": 0.012519244,
                "consumer_device": 0.03442792,
                "is_missing": "FALSE"
            },
            {
                "name": "deskjabar.pikiran-rakyat.com",
                "impressions": 2112,
                "total": 0.153367996,
                "media_distribution": 0.021471519,
                "ad_selection": 0.085886078,
                "creative_distribution": 0.01226944,
                "consumer_device": 0.033740959,
                "is_missing": "FALSE"
            }
        ]
    },
    {
        "_id": "6457537e4ef20d6f92219d51",
        "name": "Limelight",
        "total": 7,
        "pre_decarbonisation": 10,
        "carbon_reduction": 3,
        "ad_serving": 1.8,
        "media": 1.5,
        "addon": 0.9,
        "estimated": 395,
        "actual": 276.5,
        'media_distribution': 1,
        "ad_selection": 3.9,
        "creative_distribution": 0.6,
        "total_emission": 23.8,
        "total_con_emission": 16.8,
        "consumer_device": 15.3,
        "creative_con_device": 1.6,
        publishers: [
            {
                "name": "brainly.co.id",
                "impressions": 8532,
                "total": 0.867400587,
                "media_distribution": 0.11796648,
                "ad_selection": 0.478805124,
                "creative_distribution": 0.07459645,
                "consumer_device": 0.195165132,
                "is_missing": "FALSE"
            },
            {
                "name": "www.cnbcindonesia.com",
                "impressions": 5579,
                "total": 0.567185639,
                "media_distribution": 0.077137247,
                "ad_selection": 0.313086473,
                "creative_distribution": 0.048777965,
                "consumer_device": 0.127616769,
                "is_missing": "FALSE"
            },
            {
                "name": "news.detik.com",
                "impressions": 5499,
                "total": 0.559052488,
                "media_distribution": 0.076031138,
                "ad_selection": 0.308596973,
                "creative_distribution": 0.048078514,
                "consumer_device": 0.12578681,
                "is_missing": "FALSE"
            },
            {
                "name": "mail.yahoo.com",
                "impressions": 3309,
                "total": 0.336407471,
                "media_distribution": 0.045751416,
                "ad_selection": 0.185696924,
                "creative_distribution": 0.028931042,
                "consumer_device": 0.075691681,
                "is_missing": "FALSE"
            },
            {
                "name": "portalsulut.pikiran-rakyat.com",
                "impressions": 3181,
                "total": 0.323394429,
                "media_distribution": 0.043981642,
                "ad_selection": 0.178513725,
                "creative_distribution": 0.027811921,
                "consumer_device": 0.072763746,
                "is_missing": "FALSE"
            },
            {
                "name": "sport.detik.com",
                "impressions": 3087,
                "total": 0.313837976,
                "media_distribution": 0.042681965,
                "ad_selection": 0.173238563,
                "creative_distribution": 0.026990066,
                "consumer_device": 0.070613545,
                "is_missing": "FALSE"
            },
            {
                "name": "www.indosport.com",
                "impressions": 2464,
                "total": 0.25050106,
                "media_distribution": 0.034068144,
                "ad_selection": 0.138276585,
                "creative_distribution": 0.021543091,
                "consumer_device": 0.056362739,
                "is_missing": "FALSE"
            },
            {
                "name": "zonajakarta.pikiran-rakyat.com",
                "impressions": 2194,
                "total": 0.223051675,
                "media_distribution": 0.030335028,
                "ad_selection": 0.123124524,
                "creative_distribution": 0.019182444,
                "consumer_device": 0.050186627,
                "is_missing": "FALSE"
            },
            {
                "name": "wartaekonomi.co.id",
                "impressions": 2155,
                "total": 0.219086763,
                "media_distribution": 0.0297958,
                "ad_selection": 0.120935893,
                "creative_distribution": 0.018841462,
                "consumer_device": 0.049294522,
                "is_missing": "FALSE"
            },
            {
                "name": "deskjabar.pikiran-rakyat.com",
                "impressions": 2112,
                "total": 0.214715194,
                "media_distribution": 0.029201266,
                "ad_selection": 0.118522787,
                "creative_distribution": 0.018465507,
                "consumer_device": 0.048310919,
                "is_missing": "FALSE"
            }
        ]
    }
]

export const EmissionPublisherData = [
    {
      "name": "brainly.co.id",
      "impressions": 17064,
      "total": 1.486972434,
      "media_distribution": 0.204706538,
      "ad_selection": 0.825765359,
      "creative_distribution": 0.124162198,
      "consumer_device": 0.331470939,
      "is_missing": "FALSE"
    },
    {
      "name": "www.cnbcindonesia.com",
      "impressions": 11158,
      "total": 0.972318239,
      "media_distribution": 0.133855811,
      "ad_selection": 0.539960728,
      "creative_distribution": 0.081188573,
      "consumer_device": 0.216745941,
      "is_missing": "FALSE"
    },
    {
      "name": "news.detik.com",
      "impressions": 10998,
      "total": 0.958375693,
      "media_distribution": 0.131936387,
      "ad_selection": 0.532217968,
      "creative_distribution": 0.08002437,
      "consumer_device": 0.213637915,
      "is_missing": "FALSE"
    },
    {
      "name": "mail.yahoo.com",
      "impressions": 6618,
      "total": 0.576698522,
      "media_distribution": 0.079392163,
      "ad_selection": 0.320259912,
      "creative_distribution": 0.048154327,
      "consumer_device": 0.128555712,
      "is_missing": "FALSE"
    },
    {
      "name": "portalsulut.pikiran-rakyat.com",
      "impressions": 6362,
      "total": 0.554390449,
      "media_distribution": 0.076321085,
      "ad_selection": 0.307871496,
      "creative_distribution": 0.046291603,
      "consumer_device": 0.123582871,
      "is_missing": "FALSE"
    },
    {
      "name": "sport.detik.com",
      "impressions": 6174,
      "total": 0.538007959,
      "media_distribution": 0.074065762,
      "ad_selection": 0.298773753,
      "creative_distribution": 0.044923665,
      "consumer_device": 0.119930941,
      "is_missing": "FALSE"
    },
    {
      "name": "www.indosport.com",
      "impressions": 4928,
      "total": 0.429430389,
      "media_distribution": 0.05911825,
      "ad_selection": 0.238477009,
      "creative_distribution": 0.035857437,
      "consumer_device": 0.095727191,
      "is_missing": "FALSE"
    },
    {
      "name": "zonajakarta.pikiran-rakyat.com",
      "impressions": 4388,
      "total": 0.382374299,
      "media_distribution": 0.052640195,
      "ad_selection": 0.212345194,
      "creative_distribution": 0.031928254,
      "consumer_device": 0.085237604,
      "is_missing": "FALSE"
    },
    {
      "name": "wartaekonomi.co.id",
      "impressions": 4310,
      "total": 0.375577309,
      "media_distribution": 0.051704476,
      "ad_selection": 0.208570599,
      "creative_distribution": 0.031360705,
      "consumer_device": 0.083722442,
      "is_missing": "FALSE"
    },
    {
      "name": "deskjabar.pikiran-rakyat.com",
      "impressions": 4224,
      "total": 0.368083191,
      "media_distribution": 0.050672786,
      "ad_selection": 0.204408865,
      "creative_distribution": 0.030734946,
      "consumer_device": 0.082051878,
      "is_missing": "FALSE"
    }
  ]